export const SET_STATE = 'SET_STATE';

export const setState = (state) => ({
    type: SET_STATE, state
});
